const noop = (v) => {
    return v;
};
export const jwtDecoder = (token, options = { header: false }) => {
    const pos = options.header === true ? 0 : 1;
    const atob = window && window.atob ? window.atob : noop;
    try {
        return JSON.parse(atob(token.split('.')[pos]));
    }
    catch (e) {
        return undefined;
    }
};
